import Sentry from '@integrations/Sentry';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';

import useStyles from './PDFPreviewModal.styles';

type PdfPreviewModalProps = {
  className?: string;
  style?: React.CSSProperties;
  pdfUrl: string;
}

const PdfPreviewModal: React.FC<PdfPreviewModalProps> = (props) => {
  const { pdfUrl, className, style } = props;
  const [numPages, setNumPages] = useState(null);
  const { classes } = useStyles();
  const ref = useRef(null);
  const [width, setWidth] = useState();

  useEffect(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [ref]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div
      ref={ref}
      className={className}
      style={style}
    >
      <Document
      // ! Document component does not respect style prop
        className={classes.document}
        file={pdfUrl}
        loading={<CircularProgress
          color="inherit"
          size={50}
          thickness={2}
        />}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={Sentry.captureException}
      >
        {
          [...new Array(numPages).fill(0)].map((_, i) => {
            return (
              <Page
                key={i}
                pageNumber={i + 1}
                className={classes.page}
                width={width}
              />
            );
          })
        }
      </Document>
    </div>
  );
};

export default PdfPreviewModal;
